var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDateRangeSliderThumb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "tiavl4yg7a",
  width: "158.3%",
  height: "158.3%",
  x: "-29.2%",
  y: "-20.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "h27s267v4b",
  d: "M1 0a1 1 0 0 1 .446.106l22.001 11a1 1 0 0 1 0 1.788l-22 11A1 1 0 0 1 0 23V1a1 1 0 0 1 1-1"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 2)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#h27s267v4b",
  fill: "#000",
  filter: "url(#tiavl4yg7a)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#h27s267v4b",
  className: "slider-thumb-center"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#177991",
  d: "M5 2a1 1 0 0 1 .446.106l22.001 11a1 1 0 0 1 0 1.788l-22 11A1 1 0 0 1 4 25V3a1 1 0 0 1 1-1m.5 1.808V24.19L25.881 14z"
}))));
export default SvgDateRangeSliderThumb;